import React from 'react';
import { connect } from 'react-redux';
import toggles from '../../features';

const mapStateToProps = (state, ownProps) => ({
    env: process.env.NODE_ENV,
    role: state.currentRole ? state.currentRole : null,
    account: state.currentAccountId ? state.currentAccountId : null
});

const Feature = ({children, when, ...otherProps}) => when(toggles(otherProps)) && children;

export default connect(mapStateToProps)(Feature);